import { render, staticRenderFns } from "./OAuthIntegrationDashboard.vue?vue&type=template&id=88515eee&scoped=true&"
import script from "./OAuthIntegrationDashboard.vue?vue&type=script&lang=js&"
export * from "./OAuthIntegrationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OAuthIntegrationDashboard.vue?vue&type=style&index=0&id=88515eee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88515eee",
  null
  
)

export default component.exports